// extracted by mini-css-extract-plugin
export default {"content__Container":"styles_content__Container__O9GkO","content__Container__Close__Icon":"styles_content__Container__Close__Icon__S+V1U","message":"styles_message__7O8pE"};